export default {"src":"/_next/static/media/aol.5df0a5ec.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};